import { GetAllEmpresasGestionadasVerificadasUsuarioDtoProps } from "./DTOs/GetAllEmpresasGestionadasVerificadasUsuarioDto"
import { GetAllEmpresasUsuarioDtoProps } from "./DTOs/GetAllEmpresasUsuarioDto"
import { GetEmpresaActivaUsuarioDtoProps } from "./DTOs/GetEmpresaActivaUsuarioDto"
import { GetUsuarioLoggedDtoProps } from "./DTOs/GetUsuarioLoggedDto"
import { UsuarioReadingFiltersDtoProps } from "./DTOs/UsuarioReadingFiltersDto"
import { ValidacionesPendientesUsuarioProps } from "./Usuario.service"

export const validacionesPendientesUsuarioAdapter = (
  validacionesPendientes: ValidacionesPendientesUsuarioProps
): ValidacionesPendientesUsuarioProps => {
  return {
    hayCesiones: validacionesPendientes.hayCesiones,
    hayFacturas: validacionesPendientes.hayFacturas,
    hayPagares: validacionesPendientes.hayPagares,
  }
}

export const empresaReadingFullDtoAdapter = (
  empresa: GetAllEmpresasUsuarioDtoProps
) => ({
  id: empresa?.id,
  logo: {
    base64: empresa?.logo?.base64,
    mediaType: empresa?.logo?.mediaType,
  },
  nif: empresa?.nif,
  razonSocial: empresa?.razonSocial,
  verificada: empresa?.verificada,
})

export const GetEmpresaActivaUsuarioDtoAdapter = (
  empresa: GetEmpresaActivaUsuarioDtoProps
) => ({
  id: empresa.id,
  asesoria: {
    invitacionId: empresa.asesoria?.invitacionId,
    logo: {
      base64: empresa.asesoria?.logo?.base64,
      mediaType: empresa.asesoria?.logo?.mediaType,
    },
    provinciaRegistroMercantil: empresa.asesoria?.provinciaRegistroMercantil,
    razonSocial: empresa.asesoria?.razonSocial,
  },
  cnae: {
    id: empresa.cnae?.id,
    industriaId: empresa.cnae?.industriaId,
  },
  logo: {
    base64: empresa.logo?.base64,
    mediaType: empresa.logo?.mediaType,
  },
  fechaConstitucion: empresa.fechaConstitucion,
  nif: empresa.nif,
  provinciaId: empresa.provinciaId,
  razonSocial: empresa.razonSocial,
  verificada: empresa.verificada,
})

export const getAllEmpresasGestionadasVerificadasUsuarioAdapter = (
  empresa: GetAllEmpresasGestionadasVerificadasUsuarioDtoProps
) => ({
  id: empresa?.id,
  logo: {
    base64: empresa?.logo?.base64,
    mediaType: empresa?.logo?.mediaType,
  },
  nif: empresa?.nif,
  razonSocial: empresa?.razonSocial,
})

export const getUsuarioByCurrentUserAdapter = (
  userData?: GetUsuarioLoggedDtoProps
): GetUsuarioLoggedDtoProps => ({
  id: userData?.id,
  persona: {
    id: userData?.persona?.id,
    apellidos: userData?.persona?.apellidos,
    nombre: userData?.persona?.nombre,
  },
  asesoriaActivaId: userData?.asesoriaActivaId,
  email: userData?.email,
  empresaActiva: {
    cif: userData?.empresaActiva?.cif,
    configuracion: userData?.empresaActiva?.configuracion,
    direccion: userData?.empresaActiva?.direccion,
    divisaAbreviatura: userData?.empresaActiva?.divisaAbreviatura,
    email: userData?.empresaActiva?.email,
    id: userData?.empresaActiva?.id,
    pais: userData?.empresaActiva?.pais,
    razonSocial: userData?.empresaActiva?.razonSocial,
    telefono: userData?.empresaActiva?.telefono,
    tipoEmpresa: userData?.empresaActiva?.tipoEmpresa,
    nif: userData?.empresaActiva?.nif,
  },
  identityId: userData?.identityId,
  invitado: userData?.invitado,
  verificacionEmpresa: {
    tipoVerificacion: userData?.verificacionEmpresa?.tipoVerificacion,
    verificado: userData?.verificacionEmpresa?.verificado,
  },
})

export const usuarioReadingFiltersAdapter = (
  userData: UsuarioReadingFiltersDtoProps
): UsuarioReadingFiltersDtoProps => ({
  id: userData.id,
  apellidos: userData.apellidos,
  departamentos: userData.departamentos,
  email: userData.email,
  nombre: userData.nombre,
  verificado: userData.verificado,
})
